import * as React from "react";
const SvgCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M38 37v-4m8 4v-4m-9 8h10M35 51h14a2 2 0 0 0 2-2V37a2 2 0 0 0-2-2H35a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
    />
  </svg>
);
export default SvgCalendar;
